/**
 * Maya Shop - Theme JavaScript
 * Main theme functionality
 */

(function() {
  'use strict';

  // Initialize theme
  var MayaShop = {
    // Product page state
    productImages: [],
    currentImageIndex: 0,
    productUnitPrice: 0,

    init: function() {
      this.initCart();
      this.initProductPage();
      this.initNewsletterForm();
    },

    // ==========================================
    // CART FUNCTIONALITY
    // ==========================================
    initCart: function() {
      var self = this;
      document.querySelectorAll('[data-add-to-cart]').forEach(function(button) {
        button.addEventListener('click', function(e) {
          self.addToCart(e);
        });
      });
    },

    addToCart: function(event) {
      event.preventDefault();
      var self = this;
      var button = event.currentTarget;
      var form = button.closest('form');
      
      if (!form) return;

      var formData = new FormData(form);
      
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(function(response) { return response.json(); })
      .then(function(data) {
        self.updateCartCount();
        // Open cart drawer if available
        if (typeof openCartDrawer === 'function') {
          openCartDrawer();
        }
      })
      .catch(function(error) {
        console.error('Error adding to cart:', error);
      });
    },

    updateCartCount: function() {
      fetch('/cart.js')
        .then(function(response) { return response.json(); })
        .then(function(cart) {
          var cartCountElements = document.querySelectorAll('[data-cart-count]');
          cartCountElements.forEach(function(element) {
            element.textContent = cart.item_count;
            element.style.display = cart.item_count > 0 ? 'flex' : 'none';
          });
        });
    },

    // ==========================================
    // PRODUCT PAGE FUNCTIONALITY
    // ==========================================
    initProductPage: function() {
      var productSection = document.querySelector('[data-product-section]');
      if (!productSection) return;

      var self = this;

      // Get product data from data attributes
      var imagesData = productSection.dataset.productImages;
      if (imagesData) {
        try {
          this.productImages = JSON.parse(imagesData);
        } catch (e) {
          this.productImages = [];
        }
      }

      var priceData = productSection.dataset.productPrice;
      if (priceData) {
        this.productUnitPrice = parseInt(priceData) || 0;
      }

      this.currentImageIndex = 0;

      // Initialize image carousel
      this.initImageCarousel();
      
      // Initialize quantity selector
      this.initQuantitySelector();

      // Initialize thumbnails
      this.initThumbnails();

      // Update total on load
      this.updateProductTotal();
    },

    // Image Carousel
    initImageCarousel: function() {
      var self = this;
      
      // Previous button
      var prevBtn = document.querySelector('[data-image-prev]');
      if (prevBtn) {
        prevBtn.addEventListener('click', function(e) {
          e.preventDefault();
          self.changeProductImage('prev');
        });
      }

      // Next button
      var nextBtn = document.querySelector('[data-image-next]');
      if (nextBtn) {
        nextBtn.addEventListener('click', function(e) {
          e.preventDefault();
          self.changeProductImage('next');
        });
      }
    },

    changeProductImage: function(direction) {
      if (this.productImages.length <= 1) return;

      if (direction === 'next') {
        this.currentImageIndex = (this.currentImageIndex + 1) % this.productImages.length;
      } else {
        this.currentImageIndex = (this.currentImageIndex - 1 + this.productImages.length) % this.productImages.length;
      }

      var mainImage = document.getElementById('ProductMainImage');
      if (mainImage) {
        mainImage.src = this.productImages[this.currentImageIndex];
      }
      this.updateThumbnailSelection(this.currentImageIndex);
    },

    // Thumbnails
    initThumbnails: function() {
      var self = this;
      document.querySelectorAll('[data-thumbnail-index]').forEach(function(thumb) {
        thumb.addEventListener('click', function(e) {
          e.preventDefault();
          var index = parseInt(this.dataset.thumbnailIndex);
          var imageUrl = this.dataset.imageUrl;
          self.selectThumbnail(index, imageUrl);
        });
      });
    },

    selectThumbnail: function(index, imageUrl) {
      this.currentImageIndex = index;
      var mainImage = document.getElementById('ProductMainImage');
      if (mainImage) {
        mainImage.src = imageUrl;
      }
      this.updateThumbnailSelection(index);
    },

    updateThumbnailSelection: function(index) {
      var thumbnails = document.querySelectorAll('[data-thumbnail-index]');
      thumbnails.forEach(function(thumb, i) {
        if (i === index) {
          thumb.classList.add('border-blue-600', 'ring-2', 'ring-blue-600', 'ring-offset-2');
          thumb.classList.remove('border-gray-200');
        } else {
          thumb.classList.remove('border-blue-600', 'ring-2', 'ring-blue-600', 'ring-offset-2');
          thumb.classList.add('border-gray-200');
        }
      });
    },

    // Quantity Selector
    initQuantitySelector: function() {
      var self = this;
      
      // Decrease button
      var decreaseBtn = document.querySelector('[data-quantity-decrease]');
      if (decreaseBtn) {
        decreaseBtn.addEventListener('click', function(e) {
          e.preventDefault();
          self.changeQuantity(-1);
        });
      }

      // Increase button
      var increaseBtn = document.querySelector('[data-quantity-increase]');
      if (increaseBtn) {
        increaseBtn.addEventListener('click', function(e) {
          e.preventDefault();
          self.changeQuantity(1);
        });
      }

      // Input change
      var quantityInput = document.getElementById('ProductQuantity');
      if (quantityInput) {
        quantityInput.addEventListener('change', function() {
          self.validateQuantity(this);
          self.updateProductTotal();
        });
      }
    },

    changeQuantity: function(change) {
      var input = document.getElementById('ProductQuantity');
      if (!input) return;

      var currentValue = parseInt(input.value) || 1;
      var newValue = Math.max(1, currentValue + change);
      input.value = newValue;
      this.updateProductTotal();
    },

    validateQuantity: function(input) {
      var value = parseInt(input.value);
      if (isNaN(value) || value < 1) {
        input.value = 1;
      }
    },

    updateProductTotal: function() {
      var quantityInput = document.getElementById('ProductQuantity');
      var totalEl = document.getElementById('ProductTotal');
      
      if (!quantityInput || !totalEl) return;

      var quantity = parseInt(quantityInput.value) || 1;
      var total = quantity * this.productUnitPrice;
      var totalFormatted = (total / 100).toFixed(3).replace('.', ',') + ' DT';
      totalEl.textContent = totalFormatted;
    },

    // ==========================================
    // NEWSLETTER FUNCTIONALITY
    // ==========================================
    initNewsletterForm: function() {
      var self = this;
      var forms = document.querySelectorAll('[data-newsletter-form]');
      forms.forEach(function(form) {
        form.addEventListener('submit', function(e) {
          self.handleNewsletterSubmit(e);
        });
      });
    },

    handleNewsletterSubmit: function(event) {
      event.preventDefault();
      var self = this;
      var form = event.target;
      var email = form.querySelector('input[type="email"]').value;
      
      fetch('/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: 'contact[email]=' + encodeURIComponent(email) + '&form_type=customer'
      })
      .then(function() {
        self.showNewsletterSuccess(form);
      })
      .catch(function(error) {
        console.error('Newsletter error:', error);
      });
    },

    showNewsletterSuccess: function(form) {
      var message = document.createElement('div');
      message.className = 'text-green-500 text-sm mt-2';
      message.textContent = '✓ Merci pour votre inscription!';
      form.appendChild(message);
      form.querySelector('input').value = '';
      
      setTimeout(function() {
        message.remove();
      }, 5000);
    },

    // ==========================================
    // UTILITY FUNCTIONS
    // ==========================================
    toggleWishlist: function(productId) {
      console.log('Toggle wishlist for product:', productId);
      alert('Fonctionnalité à venir! Installez une app de wishlist.');
    },

    shareProduct: function(title, text, url) {
      var shareData = {
        title: title,
        text: text,
        url: url
      };
      
      if (navigator.share) {
        navigator.share(shareData)
          .then(function() { console.log('Partagé avec succès'); })
          .catch(function(error) { console.log('Erreur de partage:', error); });
      } else {
        navigator.clipboard.writeText(url)
          .then(function() { alert('Lien copié dans le presse-papiers!'); })
          .catch(function(error) { console.log('Erreur de copie:', error); });
      }
    }
  };

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { MayaShop.init(); });
  } else {
    MayaShop.init();
  }

  // Expose to global scope
  window.MayaShop = MayaShop;

  // Global function aliases for onclick handlers (backwards compatibility)
  window.changeProductImage = function(direction) { MayaShop.changeProductImage(direction); };
  window.selectThumbnail = function(element, imageUrl) {
    var index = parseInt(element.dataset.thumbnailIndex);
    MayaShop.selectThumbnail(index, imageUrl);
  };
  window.changeQuantity = function(change) { MayaShop.changeQuantity(change); };
  window.validateQuantity = function(input) { MayaShop.validateQuantity(input); };
  window.updateTotal = function() { MayaShop.updateProductTotal(); };
  window.toggleWishlist = function(productId) { MayaShop.toggleWishlist(productId); };
  window.shareProduct = function() {
    var section = document.querySelector('[data-product-section]');
    if (section) {
      MayaShop.shareProduct(
        section.dataset.productTitle || '',
        section.dataset.productDescription || '',
        section.dataset.productUrl || window.location.href
      );
    }
  };

})();
